module.exports = __webpack_public_path__ + "img/ch15_05_巡查上门.e91a0e56.jpg";